import { render, staticRenderFns } from "./ModalPharmacyExpenseCategory.vue?vue&type=template&id=6a4c8985"
import script from "./ModalPharmacyExpenseCategory.vue?vue&type=script&lang=js"
export * from "./ModalPharmacyExpenseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports